import type { MigrationTranslation } from './en';

/** Hindi. Pending review by native speakers, as the note in the interface says. */
export const migrationHi: MigrationTranslation = {
  nav: 'पुरानी बातचीत आयात करें',
  title: 'दूसरे टूल से आयात करें',
  description:
    'अपनी पिछली सपोर्ट बातचीत Hamnivo में लाएँ। जिस टूल का आप अभी उपयोग करते हैं, उसमें कुछ नहीं बदलता।',
  newImport: 'नया आयात',
  exportHistory: 'इतिहास निर्यात करें',
  loading: 'आयात लोड हो रहे हैं',
  noBrands: 'आयात से पहले एक ब्रांड जोड़ें और उसे Chatwoot से जोड़ें।',
  list: {
    title: 'आयात और निर्यात',
    empty: {
      title: 'अभी कोई आयात नहीं',
      description:
        'tawk.to, Zendesk, Intercom या Hamnivo का एक्सपोर्ट अपलोड करें, या दूसरा Chatwoot जोड़ें। कुछ भी आयात होने से पहले आप देखेंगे कि उसमें क्या है।',
    },
    columns: {
      file: 'फ़ाइल',
      kind: 'प्रकार',
      brand: 'ब्रांड',
      state: 'स्थिति',
      conversations: 'बातचीत',
      started: 'शुरू हुआ',
    },
    open: '{{name}} खोलें',
    importKind: '{{source}} से आयात',
    exportKind: 'निर्यात',
    of: '{{total}} में से {{done}}',
  },
  back: 'सभी आयात',
  steps: {
    label: 'आयात के चरण',
    source: 'स्रोत',
    sourceHint: 'एक्सपोर्ट फ़ाइल',
    check: 'जाँच',
    checkHint: 'फ़ील्ड और सेटिंग',
    sample: 'नमूना देखें',
    sampleHint: 'जाँचें और पुष्टि करें',
    import: 'आयात',
    importHint: 'चलाएँ और देखें',
    done: 'पूरा',
    current: 'मौजूदा चरण',
  },
  sources: {
    'tawk.to': 'tawk.to',
    hamnivo: 'Hamnivo पैकेज',
    chatwoot: 'Chatwoot',
    intercom: 'Intercom',
    zendesk: 'Zendesk',
  },
  state: {
    scanning: 'फ़ाइल जाँची जा रही है',
    rejected: 'फ़ाइल अस्वीकार',
    blocked: 'ध्यान देना ज़रूरी',
    ready: 'जाँच हो गई',
    dry_running: 'गिनती हो रही है',
    dry_run_ready: 'आयात के लिए तैयार',
    queued: 'शुरू होने की प्रतीक्षा',
    running: 'आयात हो रहा है',
    paused: 'रुका हुआ',
    cancelled: 'रद्द',
    completed: 'पूरा हुआ',
    failed: 'रुक गया',
    rolling_back: 'हटाया जा रहा है',
    rolled_back: 'हटा दिया गया',
    closed: 'मंज़ूर',
  },
  upload: {
    title: 'आयात शुरू करें',
    description: 'चुनें कि एक्सपोर्ट कहाँ से है और उसे अपलोड करें। अभी कुछ आयात नहीं होगा।',
    brand: 'किस ब्रांड में आयात करें',
    brandRequired: 'एक ब्रांड चुनें।',
    source: 'एक्सपोर्ट कहाँ से है',
    sourceHints: {
      'tawk.to': 'tawk.to में “Export chats” से मिली ZIP या JSON फ़ाइलें।',
      zendesk:
        'Zendesk के पूरे JSON एक्सपोर्ट की ZIP। नाम आयात करने के लिए उपयोगकर्ताओं का एक्सपोर्ट उसी ZIP में जोड़ें।',
      intercom: 'बातचीत उसी रूप में जैसे Intercom API देता है, JSON या NDJSON फ़ाइलों में।',
      hamnivo: 'Hamnivo से निर्यात किया गया या Hamnivo फ़ॉर्मेट में बना पैकेज।',
      chatwoot: 'दूसरा Chatwoot खाता, उसके किसी उपयोगकर्ता के एक्सेस टोकन से पढ़ा जाता है।',
    },
    file: 'एक्सपोर्ट फ़ाइल',
    fileHint: 'ZIP, JSON या NDJSON, 20 MB तक। पढ़ने से पहले इसमें मैलवेयर की जाँच होती है।',
    fileChosen: 'चुनी गई: {{name}} ({{size}})',
    fileRequired: 'एक्सपोर्ट फ़ाइल चुनें।',
    fileType: 'ZIP, JSON या NDJSON फ़ाइल चुनें।',
    fileTooLarge: 'यह फ़ाइल {{size}} की है। एक्सपोर्ट 20 MB तक हो सकता है।',
    chatwoot: {
      url: 'Chatwoot का पता',
      urlHint: 'उदाहरण: https://chat.example.com',
      urlRequired: 'जिस Chatwoot से आयात करना है उसका पता लिखें।',
      account: 'खाता ID',
      accountHint: 'उस Chatwoot के पता बार में /accounts/ के बाद वाली संख्या।',
      accountInvalid: 'खाता संख्या लिखें।',
      token: 'एक्सेस टोकन',
      tokenHint:
        'उस Chatwoot की प्रोफ़ाइल सेटिंग से। एडमिन का टोकन हर इनबॉक्स पढ़ता है। यह एक बार इस्तेमाल होता है, फिर मिटा दिया जाता है।',
      tokenRequired: 'एक्सेस टोकन लिखें।',
      inboxes: 'इनबॉक्स ID',
      inboxesHint: 'सिर्फ़ ये इनबॉक्स, कॉमा से अलग। सभी के लिए ख़ाली छोड़ें।',
      inboxesInvalid: 'कॉमा से अलग इनबॉक्स संख्याएँ लिखें।',
      submit: 'जोड़ें और जाँचें',
    },
    privacy:
      'इस ब्रांड के आयात संभालने वाले लोग ही फ़ाइल देख सकते हैं। आयात मंज़ूर होने या हटाए जाने पर फ़ाइल मिटा दी जाती है।',
    submit: 'अपलोड करें और जाँचें',
    uploaded: '{{name}} अपलोड हो गई। अब इसकी जाँच हो रही है।',
  },
  file: {
    uploaded: '{{time}} को अपलोड · {{size}}',
    read: '{{time}} को पढ़ा · {{size}}',
    into: '{{brand}} में',
    purged: 'फ़ाइल मिटा दी गई। गिनती और रिपोर्ट बनी रहती हैं।',
    change: 'दूसरी फ़ाइल अपलोड करें',
  },
  scanning: {
    title: 'फ़ाइल जाँची जा रही है',
    description: 'हम इसमें मैलवेयर की जाँच करते हैं और इसे पढ़ते हैं। अभी कुछ आयात नहीं हुआ।',
    apiTitle: 'Chatwoot से पढ़ा जा रहा है',
    apiDescription: 'हम बातचीत और फ़ाइलें पढ़ते हैं, फिर उनमें मैलवेयर की जाँच करते हैं। अभी कुछ आयात नहीं हुआ।',
  },
  rejected: {
    title: 'यह फ़ाइल आयात नहीं हो सकती',
    reasons: {
      malware: 'मैलवेयर स्कैनर को इस फ़ाइल में ख़तरा मिला। फ़ाइल मिटा दी गई।',
      scan_unavailable: 'मैलवेयर स्कैनर फ़ाइल की जाँच नहीं कर सका। कुछ मिनट बाद फिर कोशिश करें।',
      not_supported: 'यह ऐसा एक्सपोर्ट नहीं है जिसे हम पढ़ सकें। ZIP या JSON एक्सपोर्ट फ़ाइल चुनें।',
      truncated: 'फ़ाइल बीच में ख़त्म हो जाती है। शायद डाउनलोड पूरा नहीं हुआ। एक्सपोर्ट फिर से डाउनलोड करें।',
      corrupt: 'फ़ाइल ख़राब है और पढ़ी नहीं जा सकती। एक्सपोर्ट फिर से डाउनलोड करें।',
      too_large: 'फ़ाइल खुलकर हमारी सीमा से बड़ी हो जाती है। एक्सपोर्ट को छोटी फ़ाइलों में बाँटें।',
      too_many_files: 'आर्काइव में बहुत ज़्यादा फ़ाइलें हैं। एक्सपोर्ट को छोटी फ़ाइलों में बाँटें।',
      unsafe_path: 'आर्काइव में एक फ़ाइल का नाम सुरक्षित नहीं है।',
      not_utf8: 'फ़ाइल UTF-8 टेक्स्ट नहीं है।',
      source_denied: 'टोकन यह खाता नहीं पढ़ सकता। खाता ID जाँचें, और उसके किसी एडमिन का टोकन इस्तेमाल करें।',
      source_unreachable: 'उस Chatwoot तक नहीं पहुँचा जा सका। पता जाँचें और फिर कोशिश करें।',
      private_address: 'यह पता एक निजी नेटवर्क के अंदर है, जहाँ आयात नहीं पहुँच सकता।',
      insecure_url: 'पता https:// से शुरू होना चाहिए।',
      invalid_url: 'यह पता मान्य नहीं है।',
      unresolved: 'यह पता नहीं मिला।',
      empty: 'फ़ाइल ख़ाली है।',
      other: 'फ़ाइल पढ़ी नहीं जा सकी।',
    },
  },
  preflight: {
    title: 'एक्सपोर्ट में क्या है',
    description: 'सिर्फ़ गिनती और फ़ील्ड के नाम। कुछ भी आयात नहीं हुआ।',
    counts: {
      conversations: 'बातचीत',
      messages: 'संदेश',
      internalNotes: 'आंतरिक नोट',
      contacts: 'लोग',
      attachments: 'फ़ाइलें',
      attachmentFiles: 'शामिल फ़ाइलें',
    },
    declared: 'एक्सपोर्ट के अनुसार इसमें {{conversations}} बातचीत और {{messages}} संदेश हैं।',
    truncated: 'एक्सपोर्ट का कुछ हिस्सा गायब है',
    truncatedHint:
      'इस एक्सपोर्ट में कुछ बातचीत अधूरी हैं। वे नीचे दी गई हैं। जो है उसे आयात करें, या पहले फिर से एक्सपोर्ट करें।',
    detected: 'यह फ़ाइल {{source}} का एक्सपोर्ट लगती है। फिर से शुरू करें और {{source}} चुनें।',
    checks: {
      title: 'आयात से पहले',
      status: { ok: 'तैयार', warning: 'जाँचें', blocked: 'रुका हुआ' },
      codes: {
        authority_connected: {
          ok: 'इस ब्रांड के लिए Chatwoot जुड़ा है।',
          blocked: 'पहले इस ब्रांड को Chatwoot से जोड़ें (ब्रांड और इंस्टॉल)।',
        },
        import_inbox: {
          ok: 'आयात की गई बातचीत अपने अलग इनबॉक्स में जाती है, बिना जवाब, बॉट, असाइनमेंट या सर्वे के।',
          will_create:
            'आयात की गई बातचीत के लिए पहले आयात पर एक इनबॉक्स बनता है। वह कभी जवाब, असाइनमेंट या सर्वे नहीं भेजता।',
          blocked:
            'आयात इनबॉक्स में ऐसी सेटिंग हैं जो लोगों को सूचना भेज सकती हैं: {{detail}}। इन्हें Chatwoot में बंद करें, फिर दोबारा जाँचें।',
        },
        authority_admin: {
          ok: 'Hamnivo वे Chatwoot सेटिंग पढ़ सकता है जिनकी उसे जाँच करनी है।',
          blocked: 'Hamnivo Chatwoot सेटिंग नहीं पढ़ सकता। इस ब्रांड के लिए Chatwoot फिर से जोड़ें।',
        },
        automations: {
          ok: 'कोई Chatwoot ऑटोमेशन आयात की गई बातचीत पर काम नहीं करता।',
          blocked:
            '{{detail}} Chatwoot ऑटोमेशन आयात की गई बातचीत पर काम करेंगे। इन्हें बंद करें या आयात इनबॉक्स को बाहर रखें, फिर दोबारा जाँचें।',
        },
        integrations: {
          ok: 'किसी इंटीग्रेशन को आयात किए गए संदेश नहीं मिलते।',
          blocked: 'इन इंटीग्रेशन को आयात किए गए संदेश मिलेंगे: {{detail}}। इन्हें बंद करें, फिर दोबारा जाँचें।',
        },
        authority_unreachable: {
          ok: 'Chatwoot तक पहुँचा जा सकता है।',
          blocked: 'अभी Chatwoot तक नहीं पहुँचा जा सकता। कुछ मिनट बाद फिर कोशिश करें।',
        },
        source_access: {
          ok: 'टोकन खाते का हर इनबॉक्स पढ़ सकता है।',
          blocked: 'टोकन किसी एडमिन का नहीं है: सिर्फ़ वही इनबॉक्स पढ़े जाते हैं जो उसे दिखते हैं।',
        },
        source_mismatch: {
          ok: 'फ़ाइल आपके चुने स्रोत से मेल खाती है।',
          blocked: 'फ़ाइल आपके चुने स्रोत से मेल नहीं खाती।',
        },
      },
      settings: {
        webhook: 'वेबहुक',
        agent_bot: 'बॉट',
        auto_assignment: 'अपने-आप असाइनमेंट',
        greeting: 'स्वागत संदेश',
        csat: 'संतुष्टि सर्वे',
        working_hours: 'कामकाजी घंटों के संदेश',
        single_conversation: 'हर व्यक्ति की एक बातचीत',
      },
    },
    fields: {
      title: 'फ़ील्ड',
      description:
        'फ़ाइल का हर फ़ील्ड कैसे आयात होता है। जो फ़ील्ड आयात नहीं होते, वे यहाँ दिखते हैं, चुपचाप हटाए नहीं जाते।',
      columns: {
        source: 'फ़ाइल में फ़ील्ड',
        target: 'क्या बनता है',
        status: 'स्थिति',
        found: 'कहाँ मिला',
      },
      status: {
        supported: 'आयात होता है',
        transformed: 'आयात पर बदला जाता है',
        unsupported: 'आयात नहीं होता',
      },
      required: 'ज़रूरी',
      records: '{{count}} रिकॉर्ड',
      showUnsupported: 'आयात न होने वाले {{fields}} फ़ील्ड दिखाएँ',
      hideUnsupported: 'आयात न होने वाले फ़ील्ड छिपाएँ',
      same: 'जैसा है वैसा रहता है',
      none: '—',
      targets: {
        'conversation.source_id': 'बातचीत ID',
        'conversation.kind': 'बातचीत का प्रकार',
        'conversation.started_at': 'शुरू होने का समय',
        'conversation.completeness_check': 'पूर्णता जाँच',
        'conversation.attribute': 'बातचीत की जानकारी',
        'message.original_time': 'संदेश का मूल समय',
        'message.text': 'संदेश का टेक्स्ट',
        'message.kind': 'संदेश का प्रकार',
        'message.author': 'भेजने वाला',
        'message.author_name': 'भेजने वाले का नाम',
        'message.author_source_id': 'भेजने वाले की ID',
        'attachment.link': 'फ़ाइल का लिंक',
        'contact.source_id': 'व्यक्ति की ID',
        'contact.name': 'नाम',
        'contact.unverified_email': 'ईमेल, असत्यापित के रूप में रखा जाता है',
        'contact.unverified_phone': 'फ़ोन, असत्यापित के रूप में रखा जाता है',
        'contact.location': 'स्थान',
        'conversation.status': 'स्थिति',
        'conversation.labels': 'लेबल',
        'conversation.assignee': 'ज़िम्मेदार व्यक्ति',
        'conversation.team': 'टीम',
        'message.visibility': 'निजी या सार्वजनिक',
        'attachment.file': 'फ़ाइल',
        'contact.attribute': 'व्यक्ति की जानकारी',
        'contact.identifier': 'पहचानकर्ता',
        'conversation.subject': 'विषय',
        'conversation.channel': 'चैनल',
        'message.source_id': 'संदेश ID',
        'message.formatting': 'फ़ॉर्मैटिंग',
      },
    },
    missing: {
      title: 'एक ज़रूरी फ़ील्ड गायब है',
      description:
        'इस एक्सपोर्ट में “{{field}}” नहीं है। इसके बिना बातचीत आयात नहीं हो सकती। इसे शामिल करके फिर से एक्सपोर्ट करें।',
    },
    limits: {
      title: '{{source}} की ज्ञात सीमाएँ',
      codes: {
        tawk_export_cap:
          'tawk.to एक बार में 50 चैट तक एक्सपोर्ट करता है। हर ज़रूरी अवधि एक्सपोर्ट करें और हर फ़ाइल आयात करें।',
        tawk_rest_approval:
          'tawk.to API से सीधे आयात के लिए tawk.to की मंज़ूरी चाहिए, इसलिए आयात एक्सपोर्ट की गई फ़ाइलों से होता है।',
        tawk_attachment_links:
          'एक्सपोर्ट में फ़ाइलों के लिंक होते हैं, फ़ाइलें नहीं। फ़ाइलें आयात न होने वाली सूची में दिखती हैं।',
        tawk_tickets: 'टिकट और ऑफ़लाइन संदेश आयात नहीं होते।',
        tawk_no_notes: 'tawk.to के एक्सपोर्ट में आंतरिक नोट नहीं होते।',
        tawk_unverified_email:
          'ईमेल विज़िटर ने ख़ुद लिखे थे। इन्हें संदर्भ के लिए रखा जाता है, लोगों को मिलाने के लिए कभी नहीं।',
        chatwoot_snapshot_cap:
          'एक आयात तय संख्या में बातचीत पढ़ता है, सबसे पुरानी पहले। आगे बढ़ने के लिए इसे फिर चलाएँ: आयात हो चुकी बातचीत दोबारा नहीं पढ़ी जाती।',
        chatwoot_agent_scope: 'एजेंट का टोकन सिर्फ़ उसी एजेंट के इनबॉक्स पढ़ता है।',
        chatwoot_activity: 'गतिविधि संदेश (स्थिति बदलना, असाइनमेंट) आयात नहीं होते।',
        chatwoot_unverified_contacts:
          'ईमेल और फ़ोन नंबर असत्यापित के रूप में रखे जाते हैं; लोगों को इनसे कभी नहीं मिलाया जाता।',
        chatwoot_token_once:
          'टोकन खाता पढ़ने के लिए एक बार इस्तेमाल होता है, फिर Hamnivo से मिटा दिया जाता है। बाद में इसे Chatwoot में रद्द करें।',
        zendesk_large_tickets:
          'Zendesk 1 MB से बड़े टिकटों की टिप्पणियाँ एक्सपोर्ट नहीं करता। ऐसे टिकट अधूरे के रूप में दिखते हैं और आयात नहीं होते।',
        zendesk_users_export:
          'उपयोगकर्ताओं का एक्सपोर्ट उसी ZIP में जोड़ें। उससे नाम मिलते हैं और ग्राहक व टीम के सदस्य अलग पहचाने जाते हैं। उसके बिना अनजान लोगों की टिप्पणियाँ आयात नहीं होतीं।',
        zendesk_attachment_links:
          'एक्सपोर्ट में फ़ाइलों के लिंक होते हैं, फ़ाइलें नहीं। फ़ाइलें आयात न होने वाली सूची में दिखती हैं।',
        zendesk_history: 'टिकट का इतिहास, साइड बातचीत और कस्टम फ़ील्ड आयात नहीं होते।',
        zendesk_unverified_contacts:
          'ईमेल और फ़ोन नंबर असत्यापित के रूप में रखे जाते हैं; लोगों को इनसे कभी नहीं मिलाया जाता।',
        intercom_api_format:
          'Intercom में संदेशों के टेक्स्ट वाली कोई एक्सपोर्ट फ़ाइल नहीं है। बातचीत उसी रूप में अपलोड करें जैसे उसका API देता है।',
        intercom_parts_cap:
          'Intercom का API किसी बातचीत के ज़्यादा से ज़्यादा आख़िरी 500 हिस्से देता है। लंबी बातचीत सबसे पुराने हिस्सों के बिना आयात होती है और अधूरी के रूप में दिखती है।',
        intercom_events: 'असाइनमेंट, स्थिति बदलना और दूसरी घटनाएँ आयात नहीं होतीं।',
        intercom_plain_text: 'संदेश सादे टेक्स्ट के रूप में आयात होते हैं। फ़ॉर्मैटिंग और अंदर लगी तस्वीरें छूट जाती हैं।',
        intercom_attachment_links:
          'बातचीत में फ़ाइलों के लिंक होते हैं, फ़ाइलें नहीं। फ़ाइलें आयात न होने वाली सूची में दिखती हैं।',
        intercom_unverified_contacts:
          'ईमेल और फ़ोन नंबर असत्यापित के रूप में रखे जाते हैं; लोगों को इनसे कभी नहीं मिलाया जाता।',
        package_links_only: 'सिर्फ़ लिंक के रूप में दी गई फ़ाइलें आयात नहीं होतीं।',
      },
    },
    issues: {
      title: 'रिकॉर्ड जिन्हें देखना ज़रूरी है',
      none: 'हर रिकॉर्ड आयात हो सकता है।',
      count: '{{count}} रिकॉर्ड',
      examples: 'उदाहरण: {{ids}}',
      error: 'आयात नहीं हो सकता',
      warning: 'जाँचें',
    },
    recheck: 'दोबारा जाँचें',
    next: 'नमूना देखें',
    blocking: '“रुका हुआ” वाली चीज़ें ठीक करें, फिर दोबारा जाँचें।',
    cancel: 'आयात रद्द करें',
    cancelTitle: 'यह आयात रद्द करें?',
    cancelBody: 'कुछ भी आयात नहीं हुआ। अपलोड की गई फ़ाइल मिटा दी जाती है।',
    cancelled: 'आयात रद्द हुआ।',
  },
  reasons: {
    duplicate_existing: 'पहले से आयात किया गया',
    duplicate_in_file: 'फ़ाइल में एक से ज़्यादा बार',
    invalid_record: 'मान्य रिकॉर्ड नहीं',
    missing_time: 'समय नहीं है',
    unsupported_type: 'यह प्रकार समर्थित नहीं',
    unsupported_sender: 'यह भेजने वाला समर्थित नहीं',
    missing_conversation: 'इसकी बातचीत गायब है',
    missing_contact: 'इसका व्यक्ति गायब है',
    empty_message: 'आयात करने को कुछ नहीं',
    missing_attachment: 'फ़ाइल एक्सपोर्ट में नहीं है',
    binary_not_in_export: 'सिर्फ़ लिंक है, फ़ाइल एक्सपोर्ट में नहीं',
    checksum_mismatch: 'फ़ाइल ख़राब (चेकसम अलग)',
    type_mismatch: 'फ़ाइल का प्रकार अनुमत नहीं या दावे से अलग',
    too_large: 'बहुत बड़ा',
    malware: 'मैलवेयर मिला',
    scan_unavailable: 'जाँच नहीं हो सकी',
    authority_rejected: 'Chatwoot ने अस्वीकार किया',
    authority_unavailable: 'Chatwoot उपलब्ध नहीं था',
    parent_failed: 'इसकी बातचीत आयात नहीं हुई',
    not_referenced: 'किसी बातचीत में उपयोग नहीं',
    cancelled: 'पहले ही आयात रद्द हुआ',
    truncated: 'एक्सपोर्ट में अधूरा',
    invalid_json: 'पढ़ी न जा सकने वाली पंक्ति',
    truncated_file: 'फ़ाइल अधूरी',
    count_mismatch: 'फ़ाइल में लिखे से कम रिकॉर्ड',
    export_cap_reached: 'एक्सपोर्ट शायद 50 चैट की सीमा तक पहुँचा',
    incomplete_package: 'पैकेज के अनुसार वह अधूरा है',
    no_conversations: 'कोई बातचीत नहीं मिली',
    unknown_file: 'फ़ाइल पहचानी नहीं गई',
  },
  kinds: {
    conversation: 'बातचीत',
    message: 'संदेश',
    note: 'आंतरिक नोट',
    contact: 'लोग',
    attachment: 'फ़ाइलें',
  },
  kind: {
    conversation: 'बातचीत',
    message: 'संदेश',
    contact: 'व्यक्ति',
    attachment: 'फ़ाइल',
  },
  dryRun: {
    title: 'नमूने के नतीजे',
    description: 'आयात क्या करेगा। कुछ भी बदला नहीं गया।',
    counting: 'गिना जा रहा है कि आयात क्या करेगा…',
    ready: 'बातचीत तैयार',
    readyHint: 'ये आयात होंगी।',
    duplicates: 'डुप्लिकेट',
    duplicatesHint: 'पहले से आयात की गईं। इन्हें छोड़ा जाता है।',
    review: 'देखना ज़रूरी',
    reviewHint: 'गायब या अमान्य डेटा। सूची में, आयात नहीं।',
    messages: '{{ready}} संदेश, इनमें {{internal}} आंतरिक नोट।',
    people: 'सत्यापित ID वाले {{verified}} लोग, बिना ID के {{unverified}}।',
    peopleHint: 'लोगों को कभी भी लिखे गए ईमेल या फ़ोन से नहीं मिलाया जाता।',
    files: '{{ready}} फ़ाइलें तैयार, {{review}} को देखना ज़रूरी।',
    truncated: 'यह एक्सपोर्ट अधूरा है। रिपोर्ट बताएगी कि क्या गायब है।',
    duplicateChoice: 'डुप्लिकेट का क्या करें',
    duplicateSkip: 'मौजूदा को छोड़ें',
    duplicateHint: 'पहले से आयात की गई बातचीत छोड़ी जाती है। मूल वैसी ही रहती है।',
    destination: 'बातचीत {{brand}} में आयात होती है। इस ब्रांड की पहुँच वाले लोग ही इसे देख सकते हैं।',
    nothingSent: 'आयात के दौरान ग्राहकों या साथियों को कुछ नहीं भेजा जाता।',
    report: 'समीक्षा रिपोर्ट डाउनलोड करें',
    run: 'आयात चलाएँ',
    runTitle: '{{count}} बातचीत {{brand}} में आयात करें?',
    runBody: 'बातचीत अपना मूल समय रखती है, और आंतरिक नोट निजी रहते हैं। आप कभी भी रोक या रद्द कर सकते हैं।',
    runSubmit: 'आयात शुरू करें',
    started: 'आयात शुरू हुआ।',
    again: 'फिर से गिनें',
  },
  sample: {
    title: 'नमूना बातचीत',
    description: 'फ़ाइल की एक बातचीत, जैसी वह दिखेगी। ईमेल और नंबर छिपाए गए हैं।',
    choose: 'नमूना',
    option: 'बातचीत {{number}}',
    loading: 'नमूना लोड हो रहा है',
    source: 'एक्सपोर्ट में',
    imported: 'Hamnivo में',
    notYet: 'अभी आयात नहीं हुई।',
    started: '{{time}} को शुरू',
    internal: 'आंतरिक नोट',
    authors: { customer: 'ग्राहक', agent: 'साथी', bot: 'बॉट', system: 'सिस्टम' },
    noText: 'कोई टेक्स्ट नहीं',
    originalTime: 'मूल समय {{time}}',
    importedAt: '{{time}} को आयात',
    matches: 'एक्सपोर्ट से मेल खाती है',
    differs: 'एक्सपोर्ट से अलग है',
    problems: {
      order_or_count: 'संदेश गायब हैं या क्रम अलग है।',
      original_time: 'एक संदेश का मूल समय अलग है।',
      visibility: 'एक संदेश की दृश्यता अलग है।',
    },
    unavailable: 'नमूने उपलब्ध नहीं: एक्सपोर्ट फ़ाइल मिटा दी गई।',
  },
  progress: {
    title: 'आयात की प्रगति',
    queued: 'शुरू होने की प्रतीक्षा…',
    count: '{{total}} में से {{done}} बातचीत आयात हुई',
    percent: '{{percent}} पूरा',
    checkpoint: '{{total}} में से बातचीत {{done}}, {{time}} को सहेजी गई',
    closeHint: 'आप यह पेज बंद कर सकते हैं। आयात पृष्ठभूमि में चलता रहता है।',
    pausing: 'अगले चेकपॉइंट पर रुकेगा…',
    cancelling: 'अगले चेकपॉइंट पर रद्द होगा…',
    paused: '{{total}} में से बातचीत {{done}} पर रुका हुआ।',
    failed: 'आयात रुक गया: {{reason}}। फिर शुरू करने पर यह अपने चेकपॉइंट से आगे चलता है।',
    errors: {
      authority_unavailable: 'Chatwoot उपलब्ध नहीं था',
      import_inbox_not_quiet: 'आयात इनबॉक्स में ऐसी सेटिंग हैं जो लोगों को सूचना भेज सकती हैं',
      internal: 'हमारी ओर से कुछ ग़लत हुआ',
      other: 'कुछ ग़लत हुआ',
    },
    pause: 'रोकें',
    resume: 'फिर शुरू करें',
    cancel: 'आयात रद्द करें',
    cancelTitle: 'यह आयात रद्द करें?',
    cancelBody: 'यह अगले चेकपॉइंट पर रुकता है। आयात हो चुकी बातचीत तब तक रहती है जब तक आप उसे हटाएँ नहीं।',
    pauseRequested: 'आयात अगले चेकपॉइंट पर रुकेगा।',
    resumed: 'आयात फिर शुरू हुआ।',
    cancelRequested: 'आयात अगले चेकपॉइंट पर रुकेगा।',
  },
  result: {
    completed: 'आयात पूरा हुआ',
    completedIssues: 'आयात कुछ समस्याओं के साथ पूरा हुआ',
    cancelled: 'आयात रद्द हुआ',
    rolledBack: 'आयात हटाया गया',
    closed: 'आयात मंज़ूर हुआ',
    finished: '{{time}} को पूरा',
    approved: '{{time}} को मंज़ूर',
    imported: 'बातचीत आयात हुई',
    skipped: 'छोड़ी गईं (डुप्लिकेट)',
    notImported: 'आयात नहीं हुईं',
    failed: 'विफल',
    downloadErrors: 'जो आयात नहीं हुआ उसे डाउनलोड करें',
    retry: 'विफल रिकॉर्ड फिर से आज़माएँ',
    retryHint: 'सिर्फ़ विफल रिकॉर्ड फिर भेजे जाते हैं। आयात हो चुके रिकॉर्ड कभी दोहराए नहीं जाते।',
    retried: 'विफल रिकॉर्ड फिर से आज़माए जा रहे हैं।',
  },
  review: {
    title: 'मिलान',
    description: 'एक्सपोर्ट का हर रिकॉर्ड, और उसका क्या हुआ।',
    columns: {
      kind: 'रिकॉर्ड',
      discovered: 'एक्सपोर्ट में',
      imported: 'आयात हुए',
      skipped: 'छोड़े गए',
      quarantined: 'आयात नहीं हुए',
      failed: 'विफल',
      pending: 'पहुँचे नहीं',
      rolledBack: 'हटाए गए',
    },
    missingFromExport: 'एक्सपोर्ट में बताए गए पर उसमें नहीं: {{messages}} संदेश, {{conversations}} बातचीत।',
    checks: {
      title: 'जाँचें',
      passed: 'सफल',
      failed: 'विफल',
      codes: {
        all_accounted: 'हर रिकॉर्ड आयात हुआ या उसका कारण दर्ज है',
        no_failures: 'किसी रिकॉर्ड का आयात विफल नहीं हुआ',
        export_complete: 'एक्सपोर्ट पूरा था',
        no_duplicates: 'कुछ भी दो बार आयात नहीं हुआ',
        private_kept_private: 'आंतरिक नोट निजी रहे',
        nothing_sent: 'ग्राहकों को कुछ नहीं भेजा गया',
        sample_matches: 'नमूना बातचीत एक्सपोर्ट से मेल खाती है',
        nothing_left: 'आयात ने जो बनाया था वह सब हटा दिया गया',
      },
    },
    reasons: { title: 'रिकॉर्ड आयात क्यों नहीं हुए', none: 'हर रिकॉर्ड आयात हुआ।' },
    unsupported: {
      title: 'फ़ील्ड जो आयात नहीं हुए',
      none: 'हर फ़ील्ड आयात हुआ।',
      count: '{{count}} रिकॉर्ड',
    },
    quarantine: {
      title: 'रिकॉर्ड जो आयात नहीं हुए',
      description: 'हर एक अपने कारण के साथ। पूरी सूची स्प्रेडशीट के रूप में डाउनलोड करें।',
      none: 'कोई रिकॉर्ड छूटा नहीं।',
      columns: {
        kind: 'प्रकार',
        id: 'एक्सपोर्ट में ID',
        conversation: 'बातचीत',
        reason: 'कारण',
      },
      more: 'और दिखाएँ',
      loading: 'रिकॉर्ड लोड हो रहे हैं',
    },
    samples: {
      title: 'नमूनों की तुलना',
      description: 'Chatwoot से पढ़ी गई बातचीत, एक्सपोर्ट के साथ।',
    },
    cutover: {
      title: 'आयात मंज़ूर करें',
      description: 'पुराना टूल बंद करने से पहले ये जाँचें।',
      checklist: {
        counts: 'गिनती आपकी उम्मीद से मेल खाती है।',
        samples: 'नमूना बातचीत सही दिखती है।',
        live: 'नई बातचीत अब Hamnivo से आती है, इसलिए कुछ भी दो बार आयात नहीं होता।',
      },
      acknowledge: 'मैं ऊपर दी गई विफल जाँचें स्वीकार करता/करती हूँ।',
      acknowledgeRequired: 'पुष्टि करें कि आप विफल जाँचें स्वीकार करते हैं।',
      approve: 'आयात मंज़ूर करें',
      approved: 'आयात मंज़ूर हुआ।',
      rollbackWindow: 'मंज़ूरी देने तक आप इस आयात से बनी हर चीज़ हटा सकते हैं।',
    },
    rollback: {
      action: 'आयात की गई बातचीत हटाएँ',
      title: 'इस आयात ने जो बनाया उसे हटाएँ?',
      body: 'इस आयात से बनी बातचीत और लोग Chatwoot से मिटा दिए जाते हैं। लाइव बातचीत और कहीं और इस्तेमाल होने वाले लोग बने रहते हैं।',
      submit: 'हटाएँ',
      started: 'आयात की गई बातचीत हटाई जा रही है।',
      done: '{{conversations}} बातचीत और {{contacts}} लोग हटाए गए।',
      kept: '{{count}} रिकॉर्ड रखे गए क्योंकि वे अभी भी उपयोग में हैं।',
    },
  },
  export: {
    title: 'इतिहास निर्यात करें',
    description:
      'किसी ब्रांड की बातचीत Hamnivo पैकेज के रूप में डाउनलोड करें: वही फ़ॉर्मेट जो आयात में इस्तेमाल होता है।',
    brand: 'ब्रांड',
    submit: 'निर्यात करें',
    queued: 'निर्यात शुरू हुआ। तैयार होने पर यह सूची में दिखेगा।',
    running: 'पैकेज तैयार हो रहा है…',
    ready: 'पैकेज तैयार है',
    download: 'पैकेज डाउनलोड करें',
    expired: 'पैकेज 24 घंटे बाद मिटा दिया गया। फिर से निर्यात करें।',
    failed: 'निर्यात विफल रहा। फिर कोशिश करें।',
  },
};
